import React, { useState } from 'react';
import { Modal, ModalBody, Table, Label, Input } from 'reactstrap';
import './index.css';
import { UserInput } from '../../CommonComponents';
import ModalService from '../../../services/ModalService';
import moment from 'moment';

const ConfirmSummaryModal = ({
  isOpen,
  toggle,
  orderNumber,
  addInvoice,
  orderData = [],
}) => {
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [invoiceNo, setInvoiceNo] = useState('');
  const [transporterName, setTransporterName] = useState('');
  const [transporterDetails, setTransporterDetails] = useState('');

  const submit = () => {
    if (!invoiceDate || !invoiceNo) {
      ModalService.openAlert('', 'Input all required details', 'error');
      return;
    }

    addInvoice({
      order_id: orderNumber,
      invoice_date: moment(invoiceDate).format('MM-DD-YYYY'),
      invoice_no: invoiceNo,
      transporter_name: transporterName || '',
      lr_dispatch_details: transporterDetails || '',
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered id="ConfirmSummaryModal">
      <ModalBody className="p-0">
        <div className="modalHeader mb-0">
          <div className="title">CONFIRMATION SUMMARY</div>
        </div>
        <div className="bodyArea">
          <Table responsive bordered>
            <thead>
              <tr>
                <th rowSpan={2}>Sr No.</th>
                <th rowSpan={2}>Material Details</th>
                <th>No. of packages</th>
                <th>Total Quantity</th>
                <th rowSpan={2}>Status</th>
                <th rowSpan={2}>Remarks</th>
              </tr>
              <tr>
                <th>Actual/Accepted Order</th>
                <th>Actual/Accepted Order</th>
              </tr>
            </thead>
            <tbody>
              {orderData.map((order, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{order.name || '-'}</td>
                    <td>
                      {order.qty || '-'}/{order.no_of_packages || '-'}
                    </td>
                    <td>
                      {order.total_quantity || '-'}/
                      {order.accepted_quantity || '-'}
                    </td>
                    <td
                      style={{
                        color:
                          order.action === 'Accepted'
                            ? 'green'
                            : order.action === 'Rejected'
                            ? 'red'
                            : order.action === 'Partially Accepted'
                            ? 'blue'
                            : 'black',
                      }}
                    >
                      {order.action === 'Accepted'
                        ? 'Accepted'
                        : order.action === 'Rejected'
                        ? 'Rejected'
                        : order.action === 'Partially Accepted'
                        ? 'Partially Accepted'
                        : '-'}
                    </td>
                    <td>{order.action_reason || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="inputHolder">
            <div>
              <Label htmlFor="date">
                Invoice Date<span style={{ color: 'blue' }}>*</span>
              </Label>
              <br />
              <input
                type="date"
                value={invoiceDate}
                onChange={(e) => setInvoiceDate(e.target.value)}
                id="date"
              />
            </div>
            <div>
              <Label htmlFor="invoiceNo">
                Invoice No<span style={{ color: 'blue' }}>*</span>
              </Label>
              <Input
                value={invoiceNo}
                onChange={(e) => setInvoiceNo(e.target.value)}
                id="invoiceNo"
                placeholder="Type Here"
              />
            </div>
          </div>
          <hr />
          <div className="modalHeader mb-0">
            <div className="title">DISPATCH DETAILS</div>
          </div>
          <div className="dispatchDetails">
            <div>
              <Label htmlFor="TransporterName">Transporter Name</Label>
              <br />
              <UserInput
                value={transporterName}
                onChange={(e) => setTransporterName(e.target.value)}
                name="TransporterName"
                placeholder="Type Here"
              />
            </div>
            <div>
              <Label htmlFor="lrDetails">LR Details/Dispatch Details</Label>
              <br />
              <UserInput
                value={transporterDetails}
                onChange={(e) => setTransporterDetails(e.target.value)}
                name="lrDetails"
                placeholder="Type Here"
              />
            </div>
          </div>
        </div>
        <div className="submitButtonHolder">
          <button className="customButton customButton_blue" onClick={submit}>
            Submit
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmSummaryModal;
